import React, { useCallback } from "react";

import FavoriteIcon from "@mui/icons-material/Favorite";
import { ActionButton } from "fe-common/ui/buttons/actionButton";
import { useDiagnosticNavigation } from "../../useDiagnosticNavigation";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SendFeedbackButtonProps {
  className?: string;
  onlyIcon?: boolean;
  onClick?: () => void;
  onClose?: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SendFeedbackButton = ({
  onClick,
  onClose,
  ...props
}: SendFeedbackButtonProps) => {
  const { setFeedbackDialogProps } = useDiagnosticNavigation();

  const handleOnClick = useCallback(() => {
    if (onClick) onClick();
    setFeedbackDialogProps({ open: true, caseId: null });
  }, [setFeedbackDialogProps, onClick]);

  return (
    <>
      <ActionButton
        className={props.className}
        label={"Feedback"}
        onClick={handleOnClick}
        icon={<FavoriteIcon />}
        iconOnly={props.onlyIcon}
      />
    </>
  );
};
